(() => {
  const body = document.body;
  const menu = document.querySelector('.lh-menu');
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu?.open) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', event => {
    if (menu?.open && (!menu.contains(event.target) || event.target.closest('.lh-menu-panel a'))) menu.open = false;
  });
  const age = document.querySelector('[data-loyalty-age]');
  if (age && typeof age.showModal === 'function') {
    let confirmed = false;
    try { confirmed = sessionStorage.getItem('loyalty-adult') === 'yes'; } catch (_) {}
    if (!confirmed) {
      age.showModal();
      age.addEventListener('cancel', event => event.preventDefault());
      const keepAgeOpen = event => {
        if (age.open && event.key === 'Escape') {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      window.addEventListener('keydown', keepAgeOpen, true);
      age.addEventListener('close', () => {
        // Legacy theme shortcuts must not bypass explicit adult confirmation.
        if (!confirmed && !age.open) age.showModal();
      });
      age.querySelector('[data-loyalty-adult]').addEventListener('click', () => {
        confirmed = true;
        window.removeEventListener('keydown', keepAgeOpen, true);
        try { sessionStorage.setItem('loyalty-adult', 'yes'); } catch (_) {}
        age.close();
        document.dispatchEvent(new CustomEvent('loyalty:age-confirmed'));
      });
    }
  }
  const rewards = body.dataset.rewardsUrl;
  if (!rewards) return;
  const localLogin = path => ['/account/login', '/customer_authentication/login'].includes(path);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('data-loyalty-login')) return;
    try {
      const url = new URL(link.href, location.origin);
      if (url.origin === location.origin && localLogin(url.pathname) && !url.searchParams.has('return_to')) {
        url.searchParams.set('return_to', rewards);
        link.href = url.href;
      }
    } catch (_) {}
  });
})();
